import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

export function useLandingPageRecentSearchesAnalytics(recentSearches) {
  const { pathname } = useLocation();
  const { setMktgPageData } = useContext(MktgDataContext);
  const lastSearchDestinationAirportCode = recentSearches?.[0]?.formData?.destinationAirportCode;
  const lastSearchOriginationAirportCode = recentSearches?.[0]?.formData?.originationAirportCode;

  useEffect(() => {
    if (
      (pathname === "/" || pathname.includes("/landing/home-page/")) &&
      recentSearches?.length > 0
    ) {
      const atRecentSearches = recentSearches
        ?.map(
          ({ formData }) =>
            `${formData?.originationAirportCode}:${formData?.destinationAirportCode}`
        )
        .join(",");

      setMktgPageData(
        {
          atrecentsearches: atRecentSearches,
          atlastsearch: `${lastSearchOriginationAirportCode}:${lastSearchDestinationAirportCode}`,
        },
        "landingHomePage"
      );
    }
  }, [pathname, recentSearches?.length]);
}
